import { legacyPageEntrypoint } from '@atlassian/jira-router-routes-legacy-page-entrypoint/src/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createLegacyEntry } from '@atlassian/jira-route-entry/src/createLegacyEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { globalSettingsIssuesWorkflowsSchemesEditRoute } from '@atlassian/jira-router-routes-legacy-global-settings-issues-workflows-schemes-edit-routes/src/globalSettingsIssuesWorkflowsSchemesEditRoute.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ProjectSettingsWorkflowsSchemesEdit } from './ui/index.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsIssuesWorkflowsSchemesEditRouteEntry = createLegacyEntry(
	globalSettingsIssuesWorkflowsSchemesEditRoute,
	() => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		resources: [navigationSidebarGlobalResource],
		entryPoint: () =>
			!fg('hix-7083-modern-read-only-workflow-diagram') ? pageEntryPoint : undefined,
		component: componentWithFG(
			'hix-7083-modern-read-only-workflow-diagram',
			ProjectSettingsWorkflowsSchemesEdit,
			ErrorPagesNotFound,
		),
	}),
);
